import TopLoadingBar from '@Components/Feedback/TopLoadingBar';
import { useAppContext } from '@Containers/AppContainer';
import LayoutContainer from '@Containers/Layout/LayoutContainer';
import ModalContainer from "@Containers/ModalContainer";
import { useSessionContext } from '@Containers/SessionContainer';
import ErrorHandler from "@Core/AppErrorHandler";
import Loader from '@Core/Loader';
import React, { createContext, Dispatch, SetStateAction, useContext, useState } from 'react';
import { ErrorBoundary } from "react-error-boundary";
import { Outlet } from "react-router";

export interface FrameContextInterface {
    cmsLoading: number;
    setCmsLoading: Dispatch<SetStateAction<number>>;
}

const FrameContext = createContext<FrameContextInterface>({
    cmsLoading: 0,
    setCmsLoading: () => null,
});

export function useFrameContext() {
    return useContext(FrameContext);
}

export default function FrameContainer({ children = undefined }) {
    const { loading } = useAppContext();
    const { user } = useSessionContext();

    const [cmsLoading, setCmsLoading] = useState<number>(0);

    const response = (
        <>
            <TopLoadingBar />
            {typeof children !== 'undefined' ? children : <Outlet />}
        </>
    )

    if (!user) {
        if (loading) {
            return <Loader />;
        }

        return response;
    }

    return (
        <FrameContext.Provider value={{
            cmsLoading, setCmsLoading,
        }}>
            <ModalContainer>
                <LayoutContainer>
                    <ErrorBoundary FallbackComponent={ErrorHandler}>
                        {loading
                            ? <Loader />
                            : response
                        }
                    </ErrorBoundary>
                </LayoutContainer>
            </ModalContainer>
        </FrameContext.Provider>
    );
}
